// src/app/pdf-to-image.service.ts
import { Injectable } from '@angular/core'
import * as pdfjsLib from 'pdfjs-dist'

pdfjsLib.GlobalWorkerOptions.workerSrc = '/assets/pdfjs/pdf.worker.min.js'


@Injectable({
  providedIn: 'root'
})
export class PdfToImageService {
  async convertLocalPdfFirstPageToImage(file: File): Promise<Blob> {
    const arrayBuffer = await file.arrayBuffer()
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise

    const page = await pdf.getPage(1)
    const viewport = page.getViewport({ scale: 2 })

    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')!

    canvas.width = viewport.width
    canvas.height = viewport.height

    await page.render({ canvasContext: context, viewport }).promise

    return await new Promise(resolve =>
      canvas.toBlob(b => resolve(b!), 'image/png')
    )
  }
}
